export const DESTINATION_INBOX = ['destinationInboxId'];
export const ORIGIN_INBOX = ['originInboxId'];
export const AUDIT_AGENT_ID = ['auditParams', 'agentId'];
export const AUDIT_AGENT_TYPE = ['auditParams', 'agentType'];